export default __webpack_public_path__ + "static/tailoredSolutions-3ce6cd1beca07450ea152181e0339f23.svg";